function checkValue(value) {
	if(value === undefined || value === null) return true;
	else if(Array.isArray(value)) {
		if(value.length === 0) return true;
		else if(value.length === 1 && value[0] === '') return true;
		else return false;
	} else return false;
}

exports.checkValue = checkValue;